import { useParams } from "react-router-dom";

export default function Result() {
  const { type } = useParams();
  let content;

  switch (type) {
    case 'gallery':
      content =
        <>
          <div className="top__banner top4">
            <div className="tb__text">
              <h1>사업실적</h1>
              <h2>BUSINESS PERFORMANCE</h2>
            </div>
          </div>

          <div className="nav__wrap">
            <div className="nav__container">
              <div className="nav">
                <div className="mnav">
                  <div className="depth depth1">
                    <span className="">사업실적</span>
                  </div>
                  <div className="depth depth2">
                    <span className="">실적갤러리</span>
                    <div className="snav">
                      <ul>
                        <li className="on"><a href="gallery"><span>실적갤러리</span></a></li>
                        <li><a href="major"><span>주요실적</span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="loc">
                  <img src="../img/ico/home_icon.png" alt="home" onClick={() => (window.location.href = '/')} className="menuPathBtn" />
                  <span className="arrow"></span>
                  <span className="menuPathBtn" onClick={() => (window.location.href = 'gallery')}>사업실적</span>
                  <span className="arrow"></span>
                  <span>실적갤러리</span>
                </div>
              </div>
            </div>
          </div>

          <section>
            <div className="container-1400">
              <div className="contents">
                <div className="content">

                  <div className="board">
                    <div className="board_top">
                      실적갤러리
                    </div>

                    <div className="sch__wrap">
                      <div className="sch">
                        <div className="schinput">
                          <input type="text" name="searchInput" value="" maxlength="10" />
                        </div>
                        <div className="schbtn searchBtn"></div>
                      </div>
                    </div>
                    <input type="hidden" name="page" value="" />
                    <div className="itemlist">
                      <div className="nodata">조회된 리스트가 없습니다.</div>
                    </div>
                    <div className="paging"></div>
                  </div>

                </div>
              </div>
            </div>
          </section>

        </>;
      break;
    case 'major':
      content =
        <>

          <div className="top__banner top4">
            <div className="tb__text">
              <h1>사업실적</h1>
              <h2>BUSINESS PERFORMANCE</h2>
            </div>
          </div>

          <div className="nav__wrap">
            <div className="nav__container">
              <div className="nav">
                <div className="mnav">
                  <div className="depth depth1">
                    <span className="">사업실적</span>
                  </div>
                  <div className="depth depth2">
                    <span className="">주요실적</span>
                    <div className="snav">
                      <ul>
                        <li><a href="gallery"><span>실적갤러리</span></a></li>
                        <li className="on"><a href="major"><span>주요실적</span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="loc">
                  <img src="../img/ico/home_icon.png" alt="home" onClick={() => (window.location.href = '/')} className="menuPathBtn" />
                  <span className="arrow"></span>
                  <span className="menuPathBtn" onClick={() => (window.location.href = 'gallery')}>사업실적</span>
                  <span className="arrow"></span>
                  <span>주요실적</span>
                </div>
              </div>
            </div>
          </div>

          <section>
            <div className="container-1400">
              <div className="contents">
                <div className="content">

                  <div className="board">
                    <div className="board_top">
                      주요실적
                    </div>
                    <input type="hidden" name="page" value="" />
                    <div className="boardlist">
                      <table className="tb__major">
                        <thead>
                          <tr>
                            <th>번호</th>
                            <th>년도</th>
                            <th>공사명</th>
                            <th>발주자</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr><td colSpan="4" className="nodata">조회된 리스트가 없습니다.</td></tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="paging"></div>
                  </div>

                </div>
              </div>
            </div>
          </section>

        </>;
      break;
    default:
      content = <h1>404 Not Found</h1>;
  }

  return (
    <>
      {content}
    </>
  );
}